import { BusinessHealthResponse } from '../types';

/**
 * API empty payload: `{ "metrics": {}, "healthscore": {}, "channels": [] }`
 * (other keys like `period` may still be present).
 */
const isEmptyBusinessHealthData = (data?: BusinessHealthResponse): boolean => {
    if (!data) return true;
    const metricsEmpty = Object.keys(data.metrics ?? {}).length === 0;
    const channelsEmpty = (data.channels ?? []).length === 0;
    const healthscoreEmpty = Object.keys(data.healthscore ?? {}).length === 0;
    return metricsEmpty && channelsEmpty && healthscoreEmpty;
};

export default isEmptyBusinessHealthData;
